export const isSandbox = true;

export const SANDBOX_CLUB_ID = 9001;
export const SANDBOX_CLUB_NAME = 'Тестовый клуб';
export const SANDBOX_REGISTRATION_URL =
  'https://lk.smartshell.gg/register?from=demo-sandbox';
